import { render, staticRenderFns } from "./PaymentTariffRuleEdit.vue?vue&type=template&id=685cc7ba&lang=pug"
import script from "./PaymentTariffRuleEdit.vue?vue&type=script&lang=js"
export * from "./PaymentTariffRuleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports